import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=0fc42f21&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=0fc42f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc42f21",
  null
  
)

export default component.exports